import React from 'react';
import { Layout, Menu } from 'antd';
import { Link, useLocation } from 'react-router-dom';
import './index.css';

const { Header: AntdHeader } = Layout;

const Header = () => {
  const location = useLocation();

  // 定义菜单项
  const menuItems = [
    {
      key: '/',
      label: <Link to="/">首页</Link>,
    },
    {
      key: '/write',
      label: <Link to="/write">文章</Link>,
    },
    {
      key: '/archive',
      label: <Link to="/archive">归档</Link>,
    },
    {
      key: '/about',
      label: <Link to="/about">我的</Link>,
    },
  ];

  // 获取当前选中的菜单项
  const selectedKey = menuItems.find(item => 
    location.pathname === item.key || 
    (item.key === '/' && location.pathname === '/')
  ) ? location.pathname : '/';

  return (
    <AntdHeader className="header">
      <div className="logo" style={{ display: 'flex', alignItems: 'center' }}>
        <Link to="/" style={{ display: 'flex', alignItems: 'center', textDecoration: 'none', color: 'white' }}>
          <img 
            src="/logo.png" 
            alt="Logo" 
            style={{ width: '40px', height: '40px', marginRight: '10px', borderRadius: '4px' }} 
          />
          <span style={{ fontSize: '18px', fontWeight: 'bold' }}>我的博客</span>
        </Link>
      </div>
      <Menu
        theme="dark"
        mode="horizontal"
        selectedKeys={[selectedKey]}
        items={menuItems}
      />
    </AntdHeader>
  );
};

export default Header;